'use client';

import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type StoreOption = { id: string; name: string };

type QuickStartStoreSelectProps = {
  stores: StoreOption[];
  selectedStoreId?: string;
  onStoreChange: (storeId: string) => void;
  isRefreshing: boolean;
};

export function QuickStartStoreSelect({
  stores,
  selectedStoreId,
  onStoreChange,
  isRefreshing,
}: QuickStartStoreSelectProps) {
  const { t } = useTranslation('setup');
  if (stores.length === 0) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="text-muted-foreground text-sm font-medium">
        {t('quickStart.storePlaceholder')}
      </span>
      <Select value={selectedStoreId} onValueChange={onStoreChange}>
        <SelectTrigger className="h-9 w-full sm:w-[220px]">
          <SelectValue placeholder={t('quickStart.storePlaceholder')} />
        </SelectTrigger>
        <SelectContent>
          {stores.map((store) => (
            <SelectItem key={store.id} value={store.id}>
              {store.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isRefreshing ? <Loader2 className="text-muted-foreground size-4 animate-spin" /> : null}
    </div>
  );
}
